import {ApiCollection} from "./api.collection";
import {Department} from "../models/department.model";


export const Departments = ApiCollection.extend({
    model: Department,
    comparator: 'name',
    url: 'api/departments',
});
